"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maskCustomerName = void 0;
/**
 * Masks a customer's full name by showing only the first name and
 * the first letter of the last name, followed by a period.
 *
 * - Capitalization is optional and controlled via the `capitalize` option.
 * - Known suffixes like "Jr.", "II", "III", etc. are excluded from the last name.
 *
 * @param fullName - The full name of the customer (e.g., "bruce avery ii")
 * @param options - Options for formatting
 * @param options.capitalize - Whether to capitalize the output (default: true)
 * @returns A masked name string (e.g., "Bruce A." or "bruce a.")
 */
const maskCustomerName = (fullName, { capitalize = true } = {}) => {
    if (!fullName)
        return '';
    const suffixes = ['jr', 'sr', 'ii', 'iii', 'iv', 'v'];
    const parts = fullName.trim().split(/\s+/);
    if (parts.length === 0)
        return '';
    const format = (str) => capitalize ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : str;
    if (parts.length === 1)
        return format(parts[0]);
    const first = format(parts[0]);
    let lastIndex = parts.length - 1;
    while (lastIndex > 0 && suffixes.includes(parts[lastIndex].toLowerCase().replace(/\./g, ''))) {
        lastIndex--;
    }
    const lastInitial = parts[lastIndex]?.charAt(0);
    const formattedInitial = capitalize ? lastInitial?.toUpperCase() : lastInitial ?? '';
    return `${first} ${formattedInitial}.`;
};
exports.maskCustomerName = maskCustomerName;
//# sourceMappingURL=customer.js.map